import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { NotificationContainer } from 'react-notifications';

import AccountMenu from './AccountMenu';

class Reviews extends Component {
    render() {
        return (
            <div className="ps-account-page ps-reviews-page">
                <div className="ps-categogy ps-categogy--separate">
                    <div className="container whiteContainer">
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <AccountMenu />
                            </div>
                            <div className="col-12 col-md-9">
                                <ul className="ps-breadcrumb">
                                    <li className="ps-breadcrumb__item">
                                        <Link to="/">My Stuff</Link>
                                    </li>
                                    <li className="ps-breadcrumb__item active" aria-current="page">
                                        Reviews & Ratings
                                    </li>
                                </ul>

                                <div className="ps-reviews__hero">
                                    <div className="ps-reviews__heroContent">
                                        <span className="ps-reviews__eyebrow">Reviews</span>
                                        <h1>Share feedback that helps other shoppers choose better</h1>
                                        <p>
                                            Your ratings and comments make the shopping experience more useful for everyone and help
                                            customers discover the right Natureway products faster.
                                        </p>

                                        <div className="ps-reviews__heroStats">
                                            <div className="ps-reviews__heroStat">
                                                <span>Rated products</span>
                                                <strong>0</strong>
                                            </div>
                                            <div className="ps-reviews__heroStat">
                                                <span>Helpful votes</span>
                                                <strong>0</strong>
                                            </div>
                                            <div className="ps-reviews__heroStat">
                                                <span>Feedback ready</span>
                                                <strong>Yes</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ps-reviews__heroMedia">
                                        <img src="/assets/img/reviews-hero.svg" alt="Reviews illustration" />
                                    </div>
                                </div>

                                <div className="ps-reviews__summary">
                                    <div className="ps-reviews__summaryCard">
                                        <i className="icon-star" />
                                        <div>
                                            <span>Write product reviews</span>
                                            <strong>Help customers find trusted products</strong>
                                        </div>
                                    </div>
                                    <div className="ps-reviews__summaryCard">
                                        <i className="icon-bag2" />
                                        <div>
                                            <span>Keep it useful</span>
                                            <strong>Talk about quality, packaging, and use</strong>
                                        </div>
                                    </div>
                                    <div className="ps-reviews__summaryCard">
                                        <i className="icon-chat" />
                                        <div>
                                            <span>Share your experience</span>
                                            <strong>Short honest reviews are always welcome</strong>
                                        </div>
                                    </div>
                                </div>

                                <div className="ps-reviews__emptyCard">
                                    <div className="ps-reviews__emptyMedia">
                                        <img src="/assets/img/reviews-empty.svg" alt="No reviews yet" />
                                    </div>
                                    <div className="ps-reviews__emptyContent">
                                        <span className="ps-reviews__emptyLabel">No reviews yet</span>
                                        <h4>No reviews found</h4>
                                        <p>Once you review a product, it will appear here with your rating and comments.</p>
                                        <Link to="/" className="ps-btn ps-btn--sm ps-btn--warning">
                                            Start shopping
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <NotificationContainer />
            </div>
        );
    }
}

export default Reviews;
